import PropTypes from 'prop-types';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import classnames from 'classnames';
import R from 'ramda';
import classNames from 'classnames';
import styles from './hero-text.css';
import Cta from '../Cta';

const HeroText = ({
    subText,
    subTextSize = 'medium',
    cta,
    theme = 'dark',
    className,
    children
}) => {
    const { div, h1, p } = hh(h);
    return (
        div({className: classnames(className, styles.container)}, [
            h1({className: classNames(styles.headerText, R.prop(`${theme}HeaderText`, styles))}, children),
            p({className: classNames(styles.subText, R.prop(subTextSize, styles), R.prop(`${theme}SubText`, styles))}, subText),
            // Call to action is optional
            cta ? h(Cta, { to: cta.href, className: styles.heroCta }, cta.text) : null
        ])
    );
};

HeroText.propTypes = {
    subText: PropTypes.string,
    subTextSize: PropTypes.oneOf(['small', 'medium']),
    cta: PropTypes.shape({ href: PropTypes.string, text: PropTypes.string }),
    theme: PropTypes.oneOf(['white', 'dark'])
};

export default HeroText;



/** WEBPACK FOOTER **
 ** ./src/HeroText/index.js
 **/